import { useState, useEffect } from "react";
import { Card, Button, Typography, Space } from "antd";
import { useTranslation } from "react-i18next";
import { TabPaneKey } from "./Health_Modal";
import { useSubscribeBroker, useBrokerMessage } from "Components/Topology/queries";

interface MQTTDiagnose {
  deviceID: string;
  cid: string;
  currentTab: TabPaneKey;
}

const { Text } = Typography;

const MQTTDiagnose = ({ deviceID, cid, currentTab }: MQTTDiagnose) => {
  const [connectDisable, setConnectDisable] = useState(false);
  const { mutateAsync: subscrubeMutation } = useSubscribeBroker();
  const { data: brokerMessage } = useBrokerMessage(deviceID, currentTab);
  const { t } = useTranslation();

  useEffect(() => {
    if (brokerMessage?.status === "connected") setConnectDisable(false);
  }, [brokerMessage?.status]);

  const dateFormat = (Receive_time: any) => {
    if (!Receive_time) return null;

    const isoTime = Receive_time.replace(/\.\d+Z$/, "Z");
    const date = new Date(isoTime);

    if (isNaN(date.getTime())) {
      console.error("Invalid date format:", Receive_time);
      return null;
    }

    const readableTime = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
      date.getDate()
    ).padStart(2, "0")} ${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(
      2,
      "0"
    )}:${String(date.getSeconds()).padStart(2, "0")}`;
    return readableTime;
  };

  return (
    <>
      {deviceID === brokerMessage?.DeviceID ? (
        <Card
          title="Broker "
          actions={[
            <Button
              type="primary"
              onClick={() => {
                subscrubeMutation({ deviceID, cid });
                setConnectDisable(true);
              }}
              disabled={connectDisable || brokerMessage?.status === "connected"}
            >
              {t("ISMS.Connect")}
            </Button>,
          ]}
        >
          <Space direction="vertical">
            <Text>
              {t("ISMS.Connection")}: {brokerMessage?.status}
            </Text>
            <Text>
              {t("ISMS.Received Message")}:
              {brokerMessage?.status === "connected" && brokerMessage?.message === ""
                ? "waitting for message..."
                : brokerMessage?.message}
            </Text>
            <Text>
              {t("ISMS.Receive Time")}: {dateFormat(brokerMessage?.receive_time)}
            </Text>
          </Space>
        </Card>
      ) : (
        <Card
          title="Broker "
          actions={[
            <Button
              type="primary"
              onClick={() => subscrubeMutation({ deviceID, cid })}
              disabled={brokerMessage?.status === "connected"}
            >
              {t("ISMS.Connect")}
            </Button>,
          ]}
        >
          <Space direction="vertical">
            <Text>{t("ISMS.Connection")}:</Text>
            <Text>{t("ISMS.Received Message")}:</Text>
            <Text>{t("ISMS.Receive Time")}:</Text>
          </Space>
        </Card>
      )}
    </>
  );
};

export default MQTTDiagnose;
